import * as constants from './dlaconstants'
const acceptedFileTypes = 'application/json'
const acceptedFileTypesArray = acceptedFileTypes.split(",").map((item) => { return item.trim() })

export function parseJSON(jsObject){
    try {
        JSON.parse(jsObject)
      return JSON.parse(jsObject);
    } catch(ex){
      return null;
    }
}


export function addSchemaErrorInfo(file, jsObject, type) {
    file.fileType = type;
    file.message = "Invalid Schema";
    file.status = "Error";
    file.readyToLoad = "false";
    file.actionClassName = "fa fa-trash-o";
    file.jsonFile = jsObject;
    return file;
}

export function addBOMImportErrorInfo(file, jsObject, type) {
    file.fileType = type;
    file.message = "BOM import disabled";
    file.status = "Error";
    file.readyToLoad = "false";
    file.actionClassName = "fa fa-trash-o";
    file.jsonFile = jsObject;
    return file;
}

export function addAdditionalInfo(file, jsObject, type) {
  
    if (type === "BOM") {
        file.developmentStyleIdentifier = jsObject[constants.BOM_JSON_ID].developmentStyleIdentifier
    } else if (type === "BOL") {
        file.developmentStyleIdentifier = jsObject[constants.BOL_JSON_ID].developmentStyleIdentifier
    }
    if(!file.developmentStyleIdentifier){
      return  addSchemaErrorInfo(file,jsObject,type);
    }
    file.fileType = type;
    file.message = constants.READY_FOR_IMPORT_LABEL;
    file.status = constants.SUCCESS;
    file.readyToLoad = "true";
    file.actionClassName = "fa fa-trash-o";
    file.jsonFile = jsObject;
    return file;
}

export function  groupBy(xs, key) {
    return xs.reduce(function (rv, x) {
        (rv[x[key]] = rv[x[key]] || []).push(x);
        return rv;
    }, {});
}

export function validateFile(currentFile){
    if (currentFile) {

        const currentFileType = currentFile.type
        const currentFileSize = currentFile.size

        let errorMsg = {
            Status: "Inprogress",
            errorMessage: "Identifying Load Type"
        }

        if (!acceptedFileTypesArray.includes(currentFileType)) {
            errorMsg = {
                Status: "Error",
                errorMessage: constants.FILE_TYPE_ERROR
            }
            return errorMsg;
        }


        if (currentFileSize > 6291456) {
            errorMsg = {
                Status: "Error",
                errorMessage: constants.FILE_SIZE_ERROR
            }
            return errorMsg;
        }

        let currentStateFiles = this.props.finalDataSet;
        let duplicate = false;
        currentStateFiles.forEach((currentStateFile) => {
            if (currentStateFile.originalFileName === currentFile.name &&
                currentStateFile.status !== "Proccessed") {
                duplicate = true;
            }
        })
        if (duplicate) {
            errorMsg = {
                Status: "Error",
                errorMessage: constants.DUPLICATE_FILE_ERROR
            }
        }


        return errorMsg
    }
}

export function createSignedURLPayload(importedFiles,uuid){
    let fileNames = [];
    importedFiles.forEach(importedFile => {  // prepare json payload to submit.
        let data = {
            "contentType": importedFile.fileObject.type,
            "fileName": importedFile.fileObject.name
        }
        fileNames.push(data);
    });
    let signedUrlmsg = {
        "requestID": uuid,
        "requestData": {
            "fileList": JSON.parse(JSON.stringify(fileNames))
        }
    }
    return signedUrlmsg;
}

